import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { VexRoutes } from '../@vex/interfaces/vex-route.interface';
import { AuthGuard } from './guards/auth.guard';

const routes: VexRoutes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages/auth/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/pages/auth/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./pages/pages/auth/register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'campaign',
    loadChildren: () =>
      import('./pages/pages/auth/campaign/campaign.module').then((m) => m.CampaignModule),
  },
  {
    path: 'membership',
    loadChildren: () =>
      import('./pages/pages/auth/register/membership/membership.module').then(
        m => m.MembershipModule
      ),
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./pages/apps/payment/payment.module').then(m => m.PaymentModule),
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./pages/pages/privacy/privacy.module').then(m => m.PrivacyModule),
  },
  {
    path: 'terms',
    loadChildren: () =>
      import('./pages/pages/terms/terms.module').then(m => m.TermsModule),
  },
  {
    path: 'slackcallback',
    loadChildren: () =>
      import('./pages/pages/slackcallback/slackcallback.module').then(
        m => m.SlackcallbackModule
      ),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./pages/pages/auth/forgot-password/forgot-password.module').then(
        m => m.ForgotPasswordModule
      ),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import(
        './pages/pages/auth/forgot-password/reset-password/reset-password.module'
      ).then(m => m.ResetPasswordModule),
  },
  {
    path: 'coming-soon',
    loadChildren: () =>
      import('./pages/pages/coming-soon/coming-soon.module').then(
        m => m.ComingSoonModule
      ),
  },
  // commented on 28 Feb, 2023 by Cai
  // no used
  // {
  //   path: 'introduction',
  //   loadChildren: () =>
  //     import('./pages/pages/introduction/introduction.module').then(
  //       (m) => m.IntroductionModule
  //     ),
  // },
  {
    path: 'account',
    loadChildren: () =>
      import('./pages/account-setup/account-setup.module').then(
        m => m.AccountSetupModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'pricing',
    loadChildren: () =>
      import('./pages/pages/pricing/pricing.module').then(m => m.PricingModule),
  },
  {
    path: 'subscribe',
    loadChildren: () =>
      import('./pages/pages/subscribe/subscribe.module').then(m => m.SubscribeModule),
  },
  {
    path: 'schedule-invite',
    loadChildren: () =>
      import('./pages/pages/invite/schedule-invite/schedule-invite.module').then(
        m => m.ScheduleInviteModule
      ),
  },

  {
    path: '',
    component: CustomLayoutComponent,
    children: [
      {
        path: 'jobsearch',
        loadChildren: () =>
          import('./pages/global-search/job-search/job-search.module').then(
            m => m.JobsearchModule
          ),
      },
      {
        path: 'candidatesearch',
        loadChildren: () =>
          import('./pages/global-search/candidate-search/candidate-search.module').then(
            m => m.CandidateSearchModule
          ),
      },
      {
        path: 'dashboards/analytics',
        redirectTo: '/',
      },
      {
        path: 'home',
        loadChildren: () =>
          import(
            './pages/dashboards/dashboard-analytics/dashboard-analytics.module'
          ).then(m => m.DashboardAnalyticsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'apps',
        children: [
          // {
          //   path: 'chat',
          //   loadChildren: () =>
          //     import('./pages/apps/chat/chat.module').then((m) => m.ChatModule),
          //   data: {
          //     toolbarShadowEnabled: true,
          //   },
          // },
          // {
          //   path: 'mail',
          //   loadChildren: () =>
          //     import('./pages/apps/mail/mail.module').then((m) => m.MailModule),
          //   data: {
          //     toolbarShadowEnabled: true,
          //     scrollDisabled: true,
          //   },
          //   canActivate: [AuthGuard],
          // },
          // {
          //   path: 'social',
          //   loadChildren: () =>
          //     import('./pages/apps/social/social.module').then(
          //       (m) => m.SocialModule
          //     ),
          // },
          {
            path: 'candidates',
            loadChildren: () =>
              import('./pages/apps/candidates/candidates.module').then(
                m => m.CandidatesModule
              ),
            canActivate: [AuthGuard],
          },
          // {
          //   path: 'calendar',
          //   loadChildren: () =>
          //     import('./pages/apps/calendar/calendars.module').then(
          //       (m) => m.CalendarsModule
          //     ),
          //   data: {
          //     toolbarShadowEnabled: true,
          //   },
          //   canActivate: [AuthGuard],
          // },
          {
            path: 'schedule',
            loadChildren: () =>
              import('./pages/apps/schedule/schedule.module').then(m => m.ScheduleModule),
            canActivate: [AuthGuard],
          },
          {
            path: 'jobs',
            loadChildren: () =>
              import('./pages/apps/jobs/jobs.module').then(m => m.JobsModule),
            canActivate: [AuthGuard],
          },
          {
            path: 'search-advance',
            loadChildren: () =>
              import('./pages/apps/advanced-search/advanced-search.module').then(
                m => m.AdvancedSearchModule
              ),
            canActivate: [AuthGuard],
          },
          // {
          //   path: 'help-center',
          //   loadChildren: () =>
          //     import('./pages/apps/help-center/help-center.module').then(
          //       (m) => m.HelpCenterModule
          //     ),
          // },
          {
            path: 'settings',
            loadChildren: () =>
              import('./pages/apps/settings/settings.module').then(m => m.SettingsModule),
            canActivate: [AuthGuard],
          },
          // {
          //   path: 'campaign',
          //   loadChildren: () =>
          //     import('./pages/apps/campaign/campaign.module').then(
          //       (m) => m.CampaignModule
          //     ),
          //   canActivate: [AuthGuard],
          // },
          // {
          //   path: 'editor',
          //   loadChildren: () =>
          //     import('./pages/apps/editor/editor.module').then(
          //       (m) => m.EditorModule
          //     ),
          // },
          {
            path: 'ai-chatbot',
            loadChildren: () =>
              import('./pages/apps/chatbot/chatbot.module').then(m => m.ChatbotModule),
            canActivate: [AuthGuard],
          },
          {
            path: 'reports',
            loadChildren: () =>
              import('./pages/apps/reports/reports.module').then(m => m.ReportModule),
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'pages',
        children: [
          // {
          //   path: 'pricing',
          //   loadChildren: () =>
          //     import('./pages/pages/pricing/pricing.module').then(
          //       (m) => m.PricingModule
          //     ),
          // },
          // {
          //   path: 'faq',
          //   loadChildren: () =>
          //     import('./pages/pages/faq/faq.module').then((m) => m.FaqModule),
          // },
          // {
          //   path: 'guides',
          //   loadChildren: () =>
          //     import('./pages/pages/guides/guides.module').then(m => m.GuidesModule),
          // },
          // {
          //   path: 'invoice',
          //   loadChildren: () =>
          //     import('./pages/pages/invoice/invoice.module').then(m => m.InvoiceModule),
          // },
          {
            path: 'error-404',
            loadChildren: () =>
              import('./pages/pages/errors/error-404/error-404.module').then(
                m => m.Error404Module
              ),
          },
          {
            path: 'error-500',
            loadChildren: () =>
              import('./pages/pages/errors/error-500/error-500.module').then(
                m => m.Error500Module
              ),
          },
        ],
      },
      // {
      //   path: 'documentation',
      //   loadChildren: () =>
      //     import('./pages/documentation/documentation.module').then(
      //       m => m.DocumentationModule
      //     ),
      //   canActivate: [AuthGuard],
      // },
      {
        path: '**',
        loadChildren: () =>
          import('./pages/pages/errors/error-404/error-404.module').then(
            m => m.Error404Module
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'corrected',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule { }
